/* src/app/user-default/user-default.component.scss */
/*# sourceMappingURL=user-default.component-NNZD6RX4.css.map */
